import type { RunnerRequestHost } from './runnerRequest';

/** Web 라우터와 프로젝트 설정 이벤트를 공용 요청의 이동 계약에 연결한다. */
export const createWebRunnerRequestHost = <
  TProject extends { id: string; name: string },
  TDaemon,
  TAgentConfig,
  TModels,
  TActiveTrigger,
>(
  data: Omit<RunnerRequestHost<TProject, TDaemon, TAgentConfig, TModels, TActiveTrigger>, 'navigation'>,
  routes: {
    currentContextQuery: string;
    pathname: string;
    searchParams: string;
    changeProject: (projectId: string) => void;
    replace: (href: string, options: { scroll: boolean }) => void;
  },
): RunnerRequestHost<TProject, TDaemon, TAgentConfig, TModels, TActiveTrigger> => ({
  ...data,
  navigation: {
    requestsHref: `/daemon-triggers${routes.currentContextQuery}`,
    changeProject: routes.changeProject,
    openRepositorySettings: () => {
      const project = data.projects.find((entry) => entry.id === data.selectedProjectId);
      if (!project) return;
      window.dispatchEvent(
        new CustomEvent('openProjectModal', {
          detail: { projectId: project.id, projectName: project.name, initialTab: 'repositories' },
        }),
      );
    },
    viewSourceTrigger: (source) => {
      const params = new URLSearchParams(routes.searchParams);
      params.set('runnerRequest', source.id);
      params.set('projectId', source.projectId);
      routes.replace(`${routes.pathname}?${params.toString()}`, { scroll: false });
    },
  },
});
